<script lang="ts">
    import { onMount } from "svelte";
    //  import { swipe } from "svelte-gestures";
    import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
    import chevronLeft from "../TopMenu/chevron-left.svg";
    import chevronRight from "../TopMenu/chevron-right.svg";

    export let id: string;
    export let run: string = undefined;

    let dom: HTMLDivElement = undefined;
    let scroller: HTMLBodyElement = undefined;
    let content: HTMLBodyElement = undefined;
    let averageWidth = 0;
    const elements = [];
    let navLeftButton: HTMLBodyElement = undefined;
    let navRightButton: HTMLBodyElement = undefined;
    let totalWidth = 0;
    let maxHeight = 0;

    function navSnap(scrollLeft?: number) {
        const sc = scrollLeft === undefined ? scroller.scrollLeft : scrollLeft;

        if (sc < averageWidth / 2) {
            navLeftButton.style.visibility = "hidden";
        } else {
            navLeftButton.style.visibility = "visible";
        }

        if (sc < totalWidth - scroller.getBoundingClientRect().width) {
            navRightButton.style.visibility = "visible";
        } else {
            navRightButton.style.visibility = "hidden";
        }

        dom.style.setProperty(
            "--parent-width",
            `${Math.floor(scroller.getBoundingClientRect().width)}px`
        );
    }

    let animateInterval: any;

    let animateScroll = function (to: number) {
        if (animateInterval) {
            clearInterval(animateInterval);
            animateInterval = undefined;
        }

        let scrollLeft = scroller.scrollLeft;
        let step = (to - scrollLeft) / 25;
        animateInterval = setInterval(() => {
            scrollLeft += step;
            scroller.scrollLeft = scrollLeft;
            if (Math.abs(to - scrollLeft) < Math.abs(step)) {
                scroller.scrollLeft = to;
                clearInterval(animateInterval);
            }
        }, 10);
    };

    let lastNav: Date;
    let currentPos: number = 0;
    function navRight() {
        lastNav = new Date();

        currentPos = Math.floor(
            currentPos + scroller.getBoundingClientRect().width
        );

        animateScroll(currentPos);
        navSnap(currentPos);
    }

    function navLeft() {
        lastNav = new Date();

        currentPos = Math.floor(
            Math.max(currentPos - scroller.getBoundingClientRect().width, 0)
        );
        animateScroll(currentPos);
        navSnap(currentPos);
    }

    let lpt: any = undefined;
    let scrollStartedAt: number;
    function scroll() {
        if (lpt) {
            clearTimeout(lpt);
        }

        if (lastNav && new Date().getTime() - lastNav.getTime() < 500) {
            return;
        }

        if (!scrollStartedAt) {
            scrollStartedAt = scroller.scrollLeft;
        }

        lpt = setTimeout(() => {
            const diff = scrollStartedAt - scroller.scrollLeft;

            if (diff < 0) {
                navRight();
            } else {
                navLeft();
            }

            scrollStartedAt = undefined;
        }, 100);
    }

    function getElementSize(item: HTMLDivElement): {
        width: number;
        height: number;
    } {
        const itemCS = getComputedStyle(item);

        const width =
            item.clientWidth +
            parseInt(itemCS.paddingLeft) +
            parseInt(itemCS.paddingRight) +
            parseInt(itemCS.marginLeft) +
            parseInt(itemCS.marginRight) +
            parseInt(itemCS.borderLeftWidth) +
            parseInt(itemCS.borderRightWidth);

        const height =
            item.clientHeight +
            parseInt(itemCS.paddingTop) +
            parseInt(itemCS.paddingBottom) +
            parseInt(itemCS.marginTop) +
            parseInt(itemCS.marginBottom) +
            parseInt(itemCS.borderTopWidth) +
            parseInt(itemCS.borderBottomWidth);

        return { width, height };
    }

    onMount(() => {
        if (run) {
            dom = document.getElementById(run) as HTMLDivElement;
        }

        //	SSR markup can be gone mid-flight while Hydrator swaps its {#if}
        //	branches after mount — bail instead of crashing the effect batch
        if (!dom || !dom.querySelector(".left")) {
            return;
        }

        dom.querySelector(".left").addEventListener("click", navLeft);
        dom.querySelector(".right").addEventListener("click", navRight);

        navLeftButton = dom.querySelector(".left");
        navRightButton = dom.querySelector(".right");

        scroller = dom.querySelector(".inner") as HTMLBodyElement;

        dom.style.setProperty(
            "--parent-width",
            `${scroller.getBoundingClientRect().width}px`
        );

        content = dom.querySelector(".block") as HTMLBodyElement;

        /*
        swipe(dom as HTMLBodyElement, {
            timeframe: 2000,
            minSwipeDistance: 25,
            touchAction: "swipe",
        });

        dom.addEventListener("swipe", (e: any) => {
            if (e.detail.direction === "left") {
                navRight();
            } else {
                navLeft();
            }
        });
        */

        window.addEventListener("resize", () => {
            navSnap();
        });

        scroller.addEventListener("scroll", () => {
            scroll();
        });

        for (const item of content.children) {
            elements.push(item);

            const { width, height } = getElementSize(item as HTMLDivElement);

            if (maxHeight < height) {
                maxHeight = height;
            }

            totalWidth += width;

            if (!averageWidth) {
                averageWidth = width;
            } else {
                averageWidth = (averageWidth + width) / 2;
            }
        }

        content.setAttribute("style", `min-width: ${totalWidth}px !important;`);

        navSnap();
    });
</script>

{#if !run}
    <div id="b-{id}" bind:this={dom} class="carousel-news">
        <div class="nav left">
            <img src={chevronLeft} alt="left" width="24" height="24" />
        </div>
        <div class="inner">
            <slot />
        </div>
        <div class="nav right">
            <img src={chevronRight} alt="right" width="24" height="24" />
        </div>
    </div>
{/if}

<Hydrator
    props={{ run: `b-${id}` }}
    component="Carousel"
    hydrate={!__ADMIN__}
/>

<style lang="scss">
    :global {
        .carousel-news {
            position: relative;
            user-select: none;
            overflow: hidden;

            .inner {
                overflow: hidden;
                overflow-x: scroll;
                position: relative;
                width: calc(100%);
                margin: auto;
                -ms-overflow-style: none;
                scrollbar-width: none;
            }

            .inner::-webkit-scrollbar {
                display: none;
            }

            .nav {
                position: absolute;
                top: calc(50% - 34px);
                padding: 10px;
                background-color: rgb(223, 18, 18);
                opacity: 0.5;
                border-radius: 25px;
                box-shadow: 2px 2px 5px -3px #000000;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                z-index: 2;
                user-select: none;
                visibility: hidden;
                img {
                    filter: invert((1));
                }
            }
            .nav:hover {
                background-color: red;
                transition: background-color 0.5s ease;
            }

            .left {
                left: 0px;
                border-radius: 0% 100% 100% 0% / 30% 52% 48% 70%;
            }

            .right {
                right: 0px;
                border-radius: 100% 0% 0% 100% / 46% 52% 48% 54%;
            }
        }

        .carousel-news .blockContainer-carousel {
            flex-wrap: nowrap;
            display: flex !important;
            align-items: flex-start;
            justify-content: flex-start;
            overflow-x: hidden !important;
        }
    }
</style>
